{
  "form": {
    "closeLabel": "Close event enquiry"
  },
  "thankYou": {
    "body": "Your event enquiry has been received."
  },
  "configError": {
    "label": "Event enquiry unavailable"
  },
  "submittedForm": {
    "collapseLabel": "Collapse enquiry details",
    "expandLabel": "Expand enquiry details"
  },
  "smsConsent": {
    "label": "Text me for follow-ups on this enquiry."
  },
  "status": {
    "updatingInquiry": "Updating your enquiry",
    "updatingInquiryDetails": "Updating the enquiry details"
  }
}
